module.exports = __webpack_public_path__ + "img/41_33.4262e4f0.png";